import React from 'react'
import t from '../../translations/i18n'
import '../../scss/garantia.scss'

export default function Garantia() {
  return (
    <div className="page-content easybuy-guarantee-page">
      <div className="container">
        <div className="easybuy-guarantee-header text-center">
          <span className="easybuy-guarantee-badge">
            <i className="la la-shield"></i>
            Garantía
          </span>

          <h2>{t('garantia.tittle')}</h2>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-9">
            <div className="easybuy-guarantee-card">
              <div className="easybuy-guarantee-item">
                <div className="easybuy-guarantee-icon">
                  <i className="la la-check-circle"></i>
                </div>

                <p>{t('garantia.p_1')}</p>
              </div>

              <div className="easybuy-guarantee-item">
                <div className="easybuy-guarantee-icon">
                  <i className="la la-check-circle"></i>
                </div>

                <p>{t('garantia.p_2')}</p>
              </div>

              <div className="easybuy-guarantee-item">
                <div className="easybuy-guarantee-icon">
                  <i className="la la-check-circle"></i>
                </div>

                <p>{t('garantia.p_3')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
